// TODO: Replace with CMS API response once the GEM Audition Application endpoint is available.
const GEMAuditionApplicationData = {
  heroTitle: "GEM Audition Application",
  heroSubTitle:
    "Showcase your talent and take the next step toward joining the GEM family.",
  sections: [
    {
      title: "About the GEM Audition",
      description:
        "The GEM Audition gives performers, models, and creatives a platform to be discovered by our talent scouts, agencies, and brand partners. Every year we review thousands of submissions to find fresh, standout talent across every category.",
    },
    {
      title: "Who Can Apply",
      description:
        "Open to all aspiring and established talent — actors, dancers, musicians, models, and content creators — aged 16 and above. No prior professional experience is required to submit an application.",
    },
    {
      title: "What You'll Need",
      description:
        "A recent photo or short video of yourself, basic contact information, and a brief description of your talent and experience. The full application form will walk you through each step.",
    },
    {
      title: "What Happens Next",
      description:
        "After you submit your application, our team reviews every entry. Shortlisted candidates will be contacted directly for the next round of the audition process.",
    },
  ],
  cta: {
    title: "Ready to take the next step?",
    description: "Start your GEM Audition application now.",
    btnTitle: "Apply Now",
  },
};

export default GEMAuditionApplicationData;
